<template>
  <!-- 面包屑 -->
  <div class="bread">
    <el-breadcrumb separator="/">
        <el-breadcrumb-item v-for="(item, index) in fromFather" :key=index :to="{ path: '/' + item.path }">{{item.name}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
   name: 'bread',
   props: ['fromFather']
}
</script>

<style lang="less" scoped>
.bread {
    width: 100%;
    height: 30px;
    margin-bottom: 10px;
    .el-breadcrumb__inner {
        cursor: pointer !important;
    }
}
</style>
